import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { logWebPageVisit } from '../lib/userActivityLog';

/**
 * Logs public web + trainer dashboard page visits. Fire-and-forget.
 * Anonymous public visits insert with user_id null (anon RLS policy).
 * Must render under BrowserRouter + AuthProvider.
 */
export function useTrainerPageVisitLogging() {
  const { user, profile } = useAuth();
  const location = useLocation();

  useEffect(() => {
    void logWebPageVisit({
      userId: user?.id ?? null,
      pathname: location.pathname,
      role: profile?.role ?? null,
      sessionId: user?.id ?? null,
    });
  }, [user?.id, profile?.role, location.pathname]);
}
